export const typography = {
    fontFamily: "Lato, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    h1: {
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '32px',
        letterSpacing: '0.15px',
        textAlign: 'left'
    },
    body1: {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0.15px',
        textAlign: 'left'
    },
    body2: {
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '0.15px',
        textAlign: 'left'
    }
};
